"use client";

import { memo } from "react";
import { SOLANA_CHAIN_IDS } from "@/lib/chains";
import AddressInput from "./AddressInput";

interface RecipientAddressInputProps {
  label: string;
  description?: string;
  headerRight?: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  chainId?: number;
  /** When true, use Solana placeholder even if chainId is not yet selected */
  isSolana?: boolean;
  required?: boolean;
  popoverModal?: boolean;
}

function RecipientAddressInput({
  label,
  description,
  headerRight,
  value,
  onChange,
  placeholder,
  chainId,
  isSolana = false,
  required = false,
  popoverModal = false,
}: RecipientAddressInputProps) {
  const isSolanaChain = isSolana || (chainId != null && SOLANA_CHAIN_IDS.has(chainId));
  const resolvedPlaceholder = placeholder ?? (isSolanaChain ? "Enter a Solana address" : "0x... or vitalik.eth");
  return (
    <AddressInput
      label={label}
      description={description}
      headerRight={headerRight}
      value={value}
      onChange={onChange}
      placeholder={resolvedPlaceholder}
      required={required}
      chainId={chainId}
      popoverModal={popoverModal}
    />
  );
}

export default memo(RecipientAddressInput);
